import ThisModel from 'js/models/group.model';

import {Backbone} from "backboneAdapter";

export default Backbone.Collection.extend({
    model: ThisModel,
    url: "/CampaignCloud/Group"
});
